const CALENDLY_URL = "https://calendly.com/ismail-ivibesconsulting/30min";
const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";
const CSS_HREF = "https://assets.calendly.com/assets/external/widget.css";

let scriptPromise;

export function loadCalendly() {
  if (window.Calendly) return Promise.resolve(window.Calendly);
  if (scriptPromise) return scriptPromise;

  if (!document.querySelector("link[data-calendly-css]")) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = CSS_HREF;
    link.dataset.calendlyCss = "true";
    document.head.appendChild(link);
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Calendly));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () =>
      window.Calendly ? resolve(window.Calendly) : reject(new Error("Calendly failed to initialize"));
    script.onerror = () => reject(new Error("Could not load Calendly widget"));
    document.body.appendChild(script);
  });

  return scriptPromise;
}

export async function openCalendly() {
  try {
    const Calendly = await loadCalendly();
    Calendly.initPopupWidget({ url: CALENDLY_URL });
  } catch (e) {
    window.location.assign(CALENDLY_URL);
  }
}
